import React from 'react';
import PropTypes from 'prop-types';

// Layout
import CoreLayout from 'components/CoreLayout';

// Router
import { createBrowserHistory as createHistory } from 'history';
import { Router as ReactRouter, Route, Switch } from 'react-router';
import routes from './routes';
import WorkEmail from 'pages/WorkEmail';

const routeElems = routes.map((route, index) => {
  return <Route {...route} key={index} />;
});

export default class SiftRouter extends React.Component {
  static contextTypes = {
    analytics: PropTypes.object.isRequired,
  };

  history = createHistory();

  componentDidMount() {
    this.history.listen(location => {
      this.context.analytics.page(location.pathname);
    });
  }

  render() {
    routeElems.push(<Route component={WorkEmail} key="404" />);

    return (
      <ReactRouter history={this.history}>
        <CoreLayout>
          <Switch>{routeElems}</Switch>
        </CoreLayout>
      </ReactRouter>
    );
  }
}
